import {Auction} from "domain-models"
import React from "react"
import {hideAuction} from "redux/actions"
import {store} from "store"
import BidButtons from "../../components/Auction/BidButtons"
import Modal from "../../components/Modal"
import Data from "./AuctionDetails/VehicleData/Data"
import Details from "./AuctionDetails/VehicleData/Details"
import Sidebar from "./AuctionDetails/VehicleData/Sidebar"
import TiresetDetails from "./AuctionDetails/TiresetData/TiresetDetails"
import TiresetSidebar from "./AuctionDetails/TiresetData/TiresetSidebar"
import {connect} from "react-redux"
import {GlobalState} from "../../state"

// Props passed from parent component
type AuctionDetailsOwnProps = {
  auction: Auction
}

// Props injected by Redux connect
type AuctionDetailsReduxProps = {
  auctionFromState: Auction | null
}

// Combined props for the component
type AuctionDetailsProps = AuctionDetailsOwnProps & AuctionDetailsReduxProps

type AuctionDetailsState = {
  showDetails: boolean
}

class AuctionDetails extends React.Component<AuctionDetailsProps, AuctionDetailsState> {
  constructor(props: AuctionDetailsProps) {
    super(props)
    this.state = {
      showDetails: true
    }
  }

  toggleDetails = () => {
    this.setState({
      showDetails: !this.state.showDetails
    })
  }

  hideModal = () => {
    store.dispatch(hideAuction())
  }

  render() {
    // Use auction from Redux state if available (updated via setAuctions), otherwise use prop
    const auction = this.props.auctionFromState || this.props.auction
    const footer = (
      <div className="px-3 py-2 font-semibold flex flex-row md:hidden justify-center border">
        <BidButtons auction={auction}/>
      </div>
    )
    const body = (
      <div className="text-gray-700 flex flex-row h-full">
        {
          this.state.showDetails ?
            <Details showDetails={true} toggleDetails={this.toggleDetails} auction={auction} close={this.hideModal}/>
            :
            <Data showDetails={false} toggleDetails={this.toggleDetails} auction={auction}/>
        }

        <div className="hidden md:block border-l w-full max-w-xs">
          <Sidebar auction={auction} close={this.hideModal}/>
        </div>
      </div>
    )

    const tiresetBody = (
      <div className="text-gray-700 flex flex-row h-full">
        <TiresetDetails auction={auction} close={this.hideModal}/>

        <div className="hidden md:block border-l w-full max-w-xs">
          <TiresetSidebar auction={auction} close={this.hideModal}/>
        </div>
      </div>
    )

    return store.getState().app.subjectType === 'Vehicle'
     ? (
      <Modal body={body} rounded={true} footer={footer} pin={true} maxWidth="6xl" bodyStyle="overflow-hidden"/>
    ) : (
      <Modal body={tiresetBody} rounded={true} footer={footer} pin={true} maxWidth="6xl" bodyStyle="overflow-hidden" />
      )
  }
}

// Export connected component with proper typing
export default connect<AuctionDetailsReduxProps, {}, AuctionDetailsOwnProps, GlobalState>(
  (state: GlobalState) => ({
    auctionFromState: state.auctions.auction
  })
)(AuctionDetails)
